import React from 'react';

const ROUTE_NOT_FOUND_BLOCK = 'route-not-found';

const RouteNotFound = () => {
  return <div className={ROUTE_NOT_FOUND_BLOCK}>404 Route not found.</div>;
};

export default RouteNotFound;
